var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rp-modal rp-omise-response",
      class: { "is-active": _vm.isActive },
      style: {
        fontFamily: _vm.globalFont
      }
    },
    [
      _c("div", { staticClass: "rp-modal-background" }),
      _vm._v(" "),
      _c("div", { staticClass: "rp-modal-content" }, [
        _c("div", { staticClass: "rp-container-modal" }, [
          _c(
            "div",
            {
              staticClass: "rp-header-modal rp-columns is-gapless is-mobile",
              style: {
                backgroundColor: _vm.primaryMainColor,
                color: _vm.primarySubColor
              }
            },
            [
              _c("div", { staticClass: "rp-column is-2" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rp-page rp-column rp-helper-text-center" },
                [_vm._v("\n          " + _vm._s(_vm.t.thankYou) + "\n        ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rp-column rp-helper-text-right is-2" },
                [
                  _c(
                    "a",
                    {
                      style: { color: _vm.primarySubColor },
                      on: { click: _vm.closeModal }
                    },
                    [
                      _c("span", { staticClass: "is-hidden-mobile" }, [
                        _vm._v(_vm._s(_vm.t.close))
                      ]),
                      _vm._v(" "),
                      _vm._m(0)
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "rp-content-modal rp-helper-text-center" }, [
            _vm.orderStatus == "successful"
              ? _c(
                  "span",
                  { staticClass: "rp-icon is-large rp-helper-text-success" },
                  [_c("i", { staticClass: "fa fa-3x fa-check-circle" })]
                )
              : _c(
                  "span",
                  { staticClass: "rp-icon is-large rp-helper-text-danger" },
                  [_c("i", { staticClass: "fa fa-3x fa-exclamation-circle" })]
                ),
            _vm._v(" "),
            _vm.orderStatus == "successful"
              ? _c("h3", { staticClass: "rp-title" }, [
                  _vm._v(_vm._s(_vm.t.successMessage))
                ])
              : _c(
                  "h3",
                  { staticClass: "rp-helper-text-danger rp-title" },
                  [
                    _c("omise-messages", {
                      attrs: { message: _vm.errorCode, locale: _vm.locale }
                    })
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.orderStatus == "error"
              ? _c("p", { staticClass: "rp-helper-text-danger" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.t.pleaseContactMerchant) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.orderStatus == "successful"
              ? _c("div", { staticClass: "rp-card-payment-slip-container" }, [
                  _c("div", { staticClass: "rp-card-payment-slip-row" }, [
                    _c("span", { staticClass: "rp-card-payment-slip-key" }, [
                      _vm._v(_vm._s(_vm.t.orderNumber) + " : ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "rp-card-payment-slip-value",
                        style: { color: _vm.color.textPrimary }
                      },
                      [_vm._v(_vm._s(_vm.orderResult.orderId))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "rp-card-payment-slip-row" }, [
                    _c("span", { staticClass: "rp-card-payment-slip-key" }, [
                      _vm._v(_vm._s(_vm.t.totalPrice) + " : ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "rp-card-payment-slip-value",
                        style: { color: _vm.color.textPrimary }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm._f("productPriceFormat")(
                                _vm.orderResult.totalPrice
                              )
                            )
                          )
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "rp-button back-to-main",
                style: {
                  backgroundColor: _vm.secondaryMainColor,
                  color: _vm.secondarySubColor
                },
                on: { click: _vm.closeModal }
              },
              [_vm._v(_vm._s(_vm.t.back))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "rp-icon" }, [
      _c("i", { staticClass: "fa fa-times" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ff2d63e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ff2d63e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OmiseResponse.vue
// module id = null
// module chunks = 